import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Image from "../../../base/multimedia/image/index.js";
import { DealsAlign, DealsPosition } from "../deals/types.js";
import { nullsToUndefined } from "../../../../helpers/null.js";
import * as S from "./styled.js";
const getDeals = (deals)=>{
    if (!deals || Object.keys(deals).length === 0) return undefined;
    return Array.isArray(deals) ? deals : [
        deals
    ];
};
export const BannerCampaignVertical = (props)=>{
    const { image: { src , title: titleImage , alt , alternative ='https://cdn.logitravel.com/comun/images/lineas/generica_1280x960.jpg' , link: imageLink  } , deals: dealsProps , title , subtitle , button , link , modifiyHoverCard =false , className , titleAs ='p'  } = props;
    const classTablet = classNames({
        'is-tablet': className?.includes('is-tablet')
    });
    const dimensions = {
        width: 435,
        height: 535
    };
    const imageProps = {
        src,
        title: titleImage,
        alt,
        alternative,
        ...dimensions,
        resize: dimensions
    };
    const renderContainer = title || subtitle || button?.content;
    const cardLink = imageLink?.href ? imageLink : link;
    const deals = getDeals(dealsProps);
    return /*#__PURE__*/ _jsxs(S.BannerCampaignVertical, {
        ...nullsToUndefined(cardLink),
        className: className,
        $modifiyHoverCard: modifiyHoverCard,
        "data-testid": "BannerCampaignVertical",
        children: [
            deals && /*#__PURE__*/ _jsx(S.Deals, {
                align: DealsAlign.center,
                className: classTablet,
                position: DealsPosition.top,
                deals: deals
            }),
            /*#__PURE__*/ _jsx(Image, {
                ...imageProps,
                className: "image-banner"
            }),
            renderContainer && /*#__PURE__*/ _jsxs(S.BannerCampaignVerticalContainer, {
                className: classTablet,
                children: [
                    /*#__PURE__*/ _jsx(S.Title, {
                        as: titleAs,
                        className: classTablet,
                        "data-testid": "BannerCampaignVerticalTitle",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(S.Subtitle, {
                        className: classTablet,
                        children: subtitle
                    }),
                    button?.content && /*#__PURE__*/ _jsx(S.Button, {
                        className: classTablet,
                        variant: "primary",
                        height: "auto",
                        children: button.content
                    })
                ]
            })
        ]
    });
};
export default BannerCampaignVertical;

//# sourceMappingURL=index.js.map